import React, { useContext, useState } from 'react';
import { Button, Form, Input, Modal, Space, message } from 'antd';
import client from '@/lib/feathers';
import { ReservationContext } from '../UpdateProcessButtonWithModal';
import { UpdateReservationsContext } from '../ReservationList';
import styles from './index.module.scss';

interface CarInfo {
  carNumber: string;
  driverName: string;
  driverPhone: string;
  fleetName: string;
}

const ArrangeCarButtonWithModal = () => {
  const { key: reservationId } = useContext(ReservationContext);
  const updateData = useContext(UpdateReservationsContext);

  const [form] = Form.useForm();

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const closeArrangementFormModal = () => {
    form.resetFields();
    setIsOpenModal(false);
  };

  const handleFormSubmit = (values: CarInfo) => {
    client
      .service('carService')
      .patch(reservationId, { ...values, status: '已安排' })
      .then(() => {
        message.success('資料更新成功!');
        closeArrangementFormModal();
        updateData();
      });
  };

  return (
    <>
      <Modal
        open={isOpenModal}
        onCancel={closeArrangementFormModal}
        footer={false}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            label="車隊名稱"
            name="fleetName"
            rules={[{ required: true, message: '請輸入車隊名稱' }]}
          >
            <Input placeholder="請輸入車隊名稱" />
          </Form.Item>
          <Form.Item
            label="車牌"
            name="carNumber"
            rules={[{ required: true, message: '請輸入車牌' }]}
          >
            <Input placeholder="請輸入車牌" />
          </Form.Item>
          <Form.Item
            label="司機姓名"
            name="driverName"
            rules={[{ required: true, message: '請輸入司機姓名' }]}
          >
            <Input placeholder="請輸入司機姓名" />
          </Form.Item>
          <Form.Item
            label="司機電話"
            name="driverPhone"
            rules={[{ required: true, message: '請輸入司機電話' }]}
          >
            <Input placeholder="請輸入司機電話" />
          </Form.Item>
          <Form.Item>
            <Space className={styles.footerButtons}>
              <Button type="primary" onClick={closeArrangementFormModal}>
                取消
              </Button>
              <Button htmlType="submit">確認</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      <Button
        className={styles.stepButton}
        onClick={() => setIsOpenModal(true)}
      >
        安排
      </Button>
    </>
  );
};

export default ArrangeCarButtonWithModal;
